import React, { useMemo, useEffect, useState } from "react";
//Import Breadcrumb
import { Container } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";

import { Search } from "lucide-react";

import Paginate from "../../../components/shared/paginate";
import { toast } from "react-toastify";
import { FetchProperties } from "../../../apis/managedByGhorfatech";
import useDebounce from "../../../hooks/useDebounce";

const Percentage = () => {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState("1");
  const [totalPages, setTotalPages] = useState("1");
  // const [users, setUsers] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 400);

  const limit = "10";

  const fetchProperties = async () => {
    try {
      const response = await FetchProperties(
        "percentage",
        currentPage,
        limit,
        ""
      );
      if (response.success) {
        setProperties(response?.data?.data);
        setFilteredProperties(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
      } else {
        toast.error("Failed to fetch properties. Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to fetch properties. Please try again later.");
    }
  };

  const searchProperties = async () => {
    try {
      const response = await FetchProperties(
        "percentage",
        currentPage,
        limit,
        keyword
      );
      if (response.success) {
        setFilteredProperties(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
      } else {
        toast.error("Failed to search properties. Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to search properties. Please try again later.");
    }
  };

  useEffect(() => {
    if (debouncedKeyword) {
      searchProperties();
    } else {
      fetchProperties();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, debouncedKeyword]);

  useEffect(() => {
    if (debouncedKeyword) {
      setCurrentPage("1");
    }
  }, [debouncedKeyword]);

  const columns = useMemo(
    () => [
      "ID",
      "Title",
      "Host Name",
      "Host Phone",
      "Started At",
      "Reservations Count",
      "Published",
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">Percentage</h1>
          <div className="lg:flex flex-col lg:border lg:border-b-0 border-gray-400 dark:border-white">
            <div className="border-x border-t lg:border-none border-gray-500 dark:border-white rounded-[6px_6px_0px_0px] w-full flex flex-col lg:flex-row justify-between gap-4 p-4">
              <div className="relative border max-w-[400px] border-gray-500 dark:border-white rounded-md w-full">
                <Search
                  size={16}
                  className="absolute left-2 bottom-1/2 translate-y-1/2"
                />
                <input
                  className="pl-8 pr-6 py-2 text-base rounded-md w-full dark:bg-darkBg2"
                  type="search"
                  placeholder="Search"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </div>
            </div>
            <div className="overflow-x-auto ">
              <div className="hidden lg:flex">
                {columns.map((column, index) => (
                  <div
                    key={`column-${index}`}
                    className={`${
                      index === 0 ? "w-[16%]" : "w-[14%]"
                    } min-w-[130px] content-center border-y border-gray-500 dark:border-white break-words py-2 text-center font-semibold`}
                  >
                    {column}
                  </div>
                ))}
              </div>
              {properties &&
                filteredProperties.map((property, index) => (
                  <>
                    <div
                      key={`property-desktop-${index}`}
                      className="hidden lg:flex"
                    >
                      <div className="w-[16%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {property._id}
                      </div>
                      <div className="w-[14%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {property.title}
                      </div>
                      <div className="w-[14%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {property.managedSubscription?.contactInfo?.firstName}
                      </div>
                      <div className="w-[14%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        +{property.managedSubscription?.contactInfo?.phone}
                      </div>
                      <div className="w-[14%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {property.managedSubscription?.startedAt
                          ?.toString()
                          ?.slice(0, 10)}
                      </div>
                      <div className="w-[14%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {property.reservationsCount}
                      </div>
                      <div className="w-[14%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {property.published ? "Yes" : "No"}
                      </div>
                    </div>
                    <div
                      key={`property-mobile-${index}`}
                      className="block lg:hidden mb-6 border-x border-y border-gray-500 dark:border-white"
                    >
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">ID</div>
                        <div>{property._id}</div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Title</div>
                        <div>{property.title}</div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Host Name</div>
                        <div>
                          {property.managedSubscription?.contactInfo?.firstName}
                        </div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Host Phone</div>
                        <div>
                          {property.managedSubscription?.contactInfo?.phone}
                        </div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Started At</div>
                        <div>
                          {property.managedSubscription?.startedAt
                            ?.toString()
                            ?.slice(0, 10)}
                        </div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Reservations Count</div>
                        <div>{property.reservationsCount}</div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Published</div>
                        <div>{property.published ? "Yes" : "No"}</div>
                      </div>
                    </div>
                  </>
                ))}
            </div>
          </div>
          <Paginate
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default Percentage;
